import './loader.css'

const Loader = () => (
    <div class="parent">
       <div class="spinner"></div>
    </div>
);

export default Loader;